import React, { Component } from 'react'
import { Container, Row, Col,Card,CardBody } from 'reactstrap';
import ReactTabe from '../common/ReactTabe'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom'
import {getRollCall} from '../../actions/rollActions'

class RollCall extends Component {
  constructor(){
    super()
    this.state={
      page:0,
      limit:30
    }
  }
  componentDidMount(){
    this.props.getRollCall({page:this.state.page,limit:this.state.limit})
  }
  getmore(pageSize, pageIndex){
    //console.log('Get more')
    //console.log(pageSize)

  }
  render() {
    const {rollcall} = this.props.rollcalls
    
    return (
      <div className="main-content">
        <Row>
          <Col md={12}>
            <Card>
              <CardBody>
                <div className="d-flex justify-content-between align-items-center">
                  <h5>Danh sach Sinh viên</h5>
                  <div>
                    <Link to="/diemdanh/new" className="btn btn-sm btn-default">Thêm mới</Link>
                    <Link to="/diemdanh/new" className="btn btn-sm btn-default">Xuất file excel</Link>
                  </div>
                </div>
                <div className="m-t-30">
                  <ReactTabe 
                  columns={[
                    {
                      id:'selection',
                      Header:({getToggleAllRowsSelectedProps}) => (
                        <div>
                          <input type='checkbox' {...getToggleAllRowsSelectedProps()}/>
                        </div>
                      ),
                      Cell: ({ row }) => (
                        <div>
                          <input type="checkbox" {...row.getToggleRowSelectedProps()} />
                        </div>
                      )
                    },
                    {
                      Header: 'ID',
                      accessor: '_id',
                    },
                    {
                      Header: 'Tên',
                      accessor: 'Name',
                    },
                    {
                      Header: 'SoLuong',
                      accessor: 'soluong',
                    },
                    {
                      Header: 'Ngày tạo',
                      accessor: 'CreateOn',
                    }
                  ]} 
                  data={rollcall} getTrProps={(state,rowInfo) => {
                    console.log(state['New State'])
                  }}
                  getmore={this.getmore}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}

RollCall.propTypes = {
  auth: PropTypes.object.isRequired,
  rollcalls:PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth,
  rollcalls:state.rollcalls,
  errors: state.errors
});


export default connect(mapStateToProps,{getRollCall})(RollCall);


// WEBPACK FOOTER //
// ./src/components/pages/RollCall.js